import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/I18nContext';
import api from '../../utils/api';

function OwnerRegister() {
  const { t } = useI18n();

  const [form, setForm] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: '',
    phone: '',
    whatsapp_number: '',
    line_id: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (form.password !== form.confirmPassword) {
      setError(t('auth.passwordsNoMatch'));
      return;
    }

    if (form.password.length < 8) {
      setError(t('auth.passwordMinLength'));
      return;
    }

    setSubmitting(true);

    try {
      await api.post('/auth/register/owner', {
        email: form.email,
        password: form.password,
        name: form.name,
        phone: form.phone || null,
        whatsapp_number: form.whatsapp_number || null,
        line_id: form.line_id || null
      });
      setSuccess(true);
    } catch (err) {
      setError(err.message || t('auth.registrationFailed'));
    } finally {
      setSubmitting(false);
    }
  }

  if (success) {
    return (
      <div style={{ minHeight: '100vh', background: 'var(--background)', display: 'flex', alignItems: 'center' }}>
        <div className="container">
          <div className="card" style={{ maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✓</div>
            <h1 style={{ fontSize: '20px', marginBottom: '8px' }}>{t('auth.registrationSubmitted')}</h1>
            <p className="text-secondary mb-4">
              {t('auth.pendingApproval')}
            </p>
            <Link to="/login" className="btn btn-primary">
              {t('auth.backToLogin')}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--background)', display: 'flex', alignItems: 'center', padding: '20px 0' }}>
      <div className="container">
        <div className="card" style={{ maxWidth: '450px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '24px', marginBottom: '8px', textAlign: 'center' }}>
            {t('auth.ownerRegistration')}
          </h1>
          <p className="text-secondary text-center mb-4">
            {t('auth.ownerRegistrationSubtitle')}
          </p>

          {error && (
            <div style={{ background: '#fef2f2', color: '#dc2626', padding: '12px', borderRadius: '6px', marginBottom: '16px', fontSize: '14px' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="label">{t('auth.name')} *</label>
              <input
                type="text"
                className="input"
                value={form.name}
                onChange={(e) => setForm(f => ({ ...f, name: e.target.value }))}
                required
              />
            </div>

            <div className="form-group">
              <label className="label">{t('common.email')} *</label>
              <input
                type="email"
                className="input"
                value={form.email}
                onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))}
                required
              />
            </div>

            <div className="form-group">
              <label className="label">{t('common.password')} *</label>
              <input
                type="password"
                className="input"
                value={form.password}
                onChange={(e) => setForm(f => ({ ...f, password: e.target.value }))}
                required
                minLength={8}
              />
            </div>

            <div className="form-group">
              <label className="label">{t('auth.confirmPassword')} *</label>
              <input
                type="password"
                className="input"
                value={form.confirmPassword}
                onChange={(e) => setForm(f => ({ ...f, confirmPassword: e.target.value }))}
                required
              />
            </div>

            <div className="form-group">
              <label className="label">{t('auth.phone')}</label>
              <input
                type="tel"
                className="input"
                value={form.phone}
                onChange={(e) => setForm(f => ({ ...f, phone: e.target.value }))}
              />
            </div>

            <div className="form-group">
              <label className="label">{t('auth.whatsappNumber')}</label>
              <input
                type="tel"
                className="input"
                value={form.whatsapp_number}
                onChange={(e) => setForm(f => ({ ...f, whatsapp_number: e.target.value }))}
              />
            </div>

            <div className="form-group">
              <label className="label">{t('auth.lineId')}</label>
              <input
                type="text"
                className="input"
                value={form.line_id}
                onChange={(e) => setForm(f => ({ ...f, line_id: e.target.value }))}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={submitting}
            >
              {submitting ? t('auth.submitting') : t('auth.submitRegistration')}
            </button>
          </form>

          <p className="text-center text-secondary mt-4" style={{ fontSize: '14px' }}>
            {t('auth.haveAccount')} <Link to="/login" style={{ color: 'var(--primary)' }}>{t('auth.loginHere')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default OwnerRegister;
